import { mainPath } from "../../lib/mainPath"
import { requestsTemplates } from "../../lib/requestsTemplates"

export const post = (departmentObj) => requestsTemplates.post(mainPath, "/departments", departmentObj)